import React from "react";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <div className="container">
      <h1>Welcome to Dashboard</h1>
      <div className="button-group">
        <button className="btn" onClick={() => navigate("/add-properties")}>Add Property</button>
        <button className="btn" onClick={() => navigate("/blog-post")}> Blogs Post</button>
      </div>
    </div>
  );
};

export default Dashboard;

